/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface CioLoadRemoverArgs {
  loadClass: string;
}

export default class CioLoadRemover extends Component<CioLoadRemoverArgs> {
  @action
  removeLoad() {
    document.querySelectorAll(`.${this.args.loadClass}`).forEach((el) => el.remove());
  }
}
